export enum GregorioGlyphType {
  PUNCTUM_INCLINATUM,
  _2_PUNCTA_INCLINATA_DESCENDENS,
  _3_PUNCTA_INCLINATA_DESCENDENS,
  _4_PUNCTA_INCLINATA_DESCENDENS,
  _5_PUNCTA_INCLINATA_DESCENDENS,
  _2_PUNCTA_INCLINATA_ASCENDENS,
  _3_PUNCTA_INCLINATA_ASCENDENS,
  _4_PUNCTA_INCLINATA_ASCENDENS,
  _5_PUNCTA_INCLINATA_ASCENDENS,
  PUNCTA_INCLINATA,
  /* !!! DO NOT CHANGE THE ENUM ORDERING BEFORE THIS LINE !!! */
  UNDETERMINED,
  VIRGA,
  STROPHA,
  STROPHA_AUCTA,
  PUNCTUM,
  ALTERATION,
  PODATUS,
  PES_QUADRATUM,
  FLEXA,
  TORCULUS,
  TORCULUS_RESUPINUS,
  TORCULUS_RESUPINUS_FLEXUS,
  PORRECTUS,
  PORRECTUS_FLEXUS,
  BIVIRGA,
  TRIVIRGA,
  DISTROPHA,
  DISTROPHA_AUCTA,
  TRISTROPHA,
  TRISTROPHA_AUCTA,
  PES_QUADRATUM_FIRST_PART,
  SCANDICUS,
  PES_QUILISMA_QUADRATUM_FIRST_PART,
  ANCUS,
  PUNCTA_ASCENDENS,
  PUNCTA_DESCENDENS,
  VIRGA_REVERSA,
  SALICUS,
  SALICUS_FLEXUS,
  PES_ASCENDENS_ORISCUS,
  PES_DESCENDENS_ORISCUS,
  TORCULUS_LIQUESCENS,
  /* additional glyph types, necessary for determination */
  PORRECTUS_NO_BAR,
  PORRECTUS_FLEXUS_NO_BAR,
  FUSED,
}
